export type OnboardingCardCopy = { title: string; subtitle: string };
export type LiveQuestOnboardingContent = {
  introDescription: string;
  playDescription: string;
  rewardsDescription: string;
  consentNotice: string;
  inactivityTerms: string;
  ways: OnboardingCardCopy[];
  stats: OnboardingCardCopy[];
  introTiles: string[];
  rewardTiles: string[];
};

/** Editorial defaults mirrored by tezda-ws. Saved dashboard copy overrides them in real time. */
export const DEFAULT_ONBOARDING_CONTENT: LiveQuestOnboardingContent = {
  introDescription: 'Watch. Chat. Stream. Earn.\nComplete quests, earn XP and unlock exclusive rewards.',
  playDescription: 'Watch. Chat. Stream. Earn.\nComplete quests, earn XP and unlock exclusive rewards.',
  rewardsDescription: 'Complete Live Quests, earn XP and unlock exclusive rewards throughout Season 1.',
  consentNotice: 'Live Quest is seasonal and separate from PingTop Level. Join PingTop Level from Settings to earn permanent P-Level XP and display a rank badge.',
  inactivityTerms: 'P-Level XP reduces proportionally during inactivity. After 180 consecutive inactive days, membership expires, progression and the badge are removed, and rejoining starts again at Lv.1.',
  ways: [
    { title: 'Watch', subtitle: 'Stay in live streams' },
    { title: 'Chat', subtitle: 'Send messages' },
    { title: 'Engage', subtitle: 'Like, react, join' },
    { title: 'Level Up', subtitle: 'Unlock rewards' },
  ],
  stats: [
    { title: '50', subtitle: 'Total levels' },
    { title: 'Free & Plus', subtitle: 'Reward Tracks' },
    { title: 'Exclusive', subtitle: 'Items & perks' },
    { title: 'Bigger Rewards', subtitle: 'as you level up' },
  ],
  introTiles: ['Tokens', 'Profile Frames', 'Entry Animation', 'Sticker Packs'],
  rewardTiles: ['Sticker Packs', 'Profile Backgrounds', 'Profile Frames', 'PingTop Plus',
    'Tokens', 'PCoins', 'Entry Animations', 'Chat Themes'],
};

export const parseOnboardingContent = (raw: unknown): LiveQuestOnboardingContent => {
  const input = raw && typeof raw === 'object' ? raw as Record<string, unknown> : {};
  const text = (value: unknown, fallback: string) =>
    typeof value === 'string' && value.trim() && value.length <= 180 ? value.trim() : fallback;
  const cards = (value: unknown, fallback: OnboardingCardCopy[]) =>
    Array.isArray(value) && value.length === fallback.length
      ? fallback.map((item, i) => ({
          title: text(value[i]?.title, item.title),
          subtitle: text(value[i]?.subtitle, item.subtitle),
        })) : fallback.map((item) => ({ ...item }));
  const labels = (value: unknown, fallback: string[]) =>
    Array.isArray(value) && value.length === fallback.length
      ? fallback.map((item, i) => text(value[i], item)) : [...fallback];
  return {
    introDescription: text(input.introDescription, DEFAULT_ONBOARDING_CONTENT.introDescription),
    playDescription: text(input.playDescription, DEFAULT_ONBOARDING_CONTENT.playDescription),
    rewardsDescription: text(input.rewardsDescription, DEFAULT_ONBOARDING_CONTENT.rewardsDescription),
    consentNotice: text(input.consentNotice, DEFAULT_ONBOARDING_CONTENT.consentNotice),
    inactivityTerms: text(input.inactivityTerms, DEFAULT_ONBOARDING_CONTENT.inactivityTerms),
    ways: cards(input.ways, DEFAULT_ONBOARDING_CONTENT.ways),
    stats: cards(input.stats, DEFAULT_ONBOARDING_CONTENT.stats),
    introTiles: labels(input.introTiles, DEFAULT_ONBOARDING_CONTENT.introTiles),
    rewardTiles: labels(input.rewardTiles, DEFAULT_ONBOARDING_CONTENT.rewardTiles),
  };
};
